import ufeApi from 'services/api/ufeApi';
import UrlUtils from 'utils/Url';
import javascriptUtils from 'utils/javascript';

const { buildQuery } = UrlUtils;
const { buildMap } = javascriptUtils;

// https://checkout-service-eus1-qa2.lower.internal.sephora.com/cart-service/swagger-ui/index.html#/Checkout%20API/getOrderPoints
function getOrderPoints({ orderId, guestEmail }) {
    const queryParams = buildQuery(buildMap({ guestEmail: encodeURIComponent(guestEmail) }));
    const url = `/api/checkout/orders/${orderId}/points${queryParams}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET'
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getOrderPoints;
